import * as React from "react";
import {
    Show,
    TextField,
    useRecordContext,
    EmailField,
    Tab,
    TabbedShowLayout,
} from "react-admin";
import { Link } from "@mui/material";
import Table from "@mui/material/Table";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { useEffect, useState } from "react";
import Typography from "@mui/material/Typography";
import CopyToClipboardButton from "../../common/CopyToClippboardButton";
import TimestampDateTimeField from "../../common/TimestampDateTimeField";

const MainTitle = () => {
    const record = useRecordContext();
    // the record can be empty while loading
    if (!record) return "[resource_name] #[record_id]";
    return <span>Transaction: #{record.id}</span>;
};

const AuthorField = () => {
    const record = useRecordContext();
    const { authorName, authorId } = record;
    return record && authorId ?
        <Link href={`/#/users/${authorId}/show/`} className="launch-link" >
            {authorName || authorId}
        </Link> : null;
}
AuthorField.defaultProps = { label: 'Author' };

const UserField = () => {
    const record = useRecordContext();
    const { userName, userId } = record;
    return record && userId ?
        <Link href={`/#/users/${userId}/show/`} className="launch-link" >
            {userName || userId}
        </Link> : null;
}
UserField.defaultProps = { label: 'User' };

const EventField = () => {
    const record = useRecordContext();
    const { eventName, eventId } = record;
    return record && eventId ?
        <Link href={`/#/posts/${eventId}/show/`} className="launch-link" >
            {eventName || eventId}
        </Link> : null;
}
EventField.defaultProps = { label: 'Event' };

export const TransactionsShow = (props) => {
    useEffect(() => {
        // console.log("Scrolling...", props);
        window.scrollTo({ top: 0, left: 0 });
    }, []);
    // eslint-disable-next-line 
    const [loaded, setLoaded] = useState(false);
    // eslint-disable-next-line 
    const [error, setError] = useState(false);

    return <Show title={<MainTitle />} {...props}>
        <>
            <TabbedShowLayout>
                <Tab label="Transaction">
                    <TableContainer
                        sx={{
                            marginTop: "20px",
                            marginBottom: "20px",
                        }}
                        component={Paper}
                    >
                        <Table size="small">
                            <TableRow>
                                <TableCell
                                    component="th"
                                    scope="row"
                                    sx={{ width: 300 }}
                                >
                                    <Typography component="span" variant="body2">
                                        ID
                                    </Typography>
                                </TableCell>
                                <TableCell component="th" scope="row">
                                    <div className="data-cell__copy-to-clipboard">
                                        <TextField source="id" />{" "}
                                        <CopyToClipboardButton source="id" />
                                    </div>
                                </TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell
                                    component="th"
                                    scope="row"
                                    sx={{ width: 300 }}
                                >
                                    <Typography component="span" variant="body2">
                                        User
                                    </Typography>
                                </TableCell>
                                <TableCell component="th" scope="row">
                                    <UserField source="userName" />
                                </TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell
                                    component="th"
                                    scope="row"
                                    sx={{ width: 300 }}
                                >
                                    <Typography component="span" variant="body2">
                                        User email
                                    </Typography>
                                </TableCell>
                                <TableCell component="th" scope="row">
                                    <EmailField source="userEmail" />
                                </TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell
                                    component="th"
                                    scope="row"
                                    sx={{ width: 300 }}
                                >
                                    <Typography component="span" variant="body2">
                                        UserId
                                    </Typography>
                                </TableCell>
                                <TableCell component="th" scope="row">
                                    <div className="data-cell__copy-to-clipboard">
                                        <TextField source="userId" />{" "}
                                        <CopyToClipboardButton source="userId" />
                                    </div>
                                </TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell
                                    component="th"
                                    scope="row"
                                    sx={{ width: 300 }}
                                >
                                    <Typography component="span" variant="body2">
                                        Event
                                    </Typography>
                                </TableCell>
                                <TableCell component="th" scope="row">
                                    <EventField source="eventName" />
                                </TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell
                                    component="th"
                                    scope="row"
                                    sx={{ width: 300 }}
                                >
                                    <Typography component="span" variant="body2">
                                        EventId
                                    </Typography>
                                </TableCell>
                                <TableCell component="th" scope="row">
                                    <div className="data-cell__copy-to-clipboard">
                                        <TextField source="eventId" />{" "}
                                        <CopyToClipboardButton source="eventId" />
                                    </div>
                                </TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell
                                    component="th"
                                    scope="row"
                                    sx={{ width: 300 }}
                                >
                                    <Typography component="span" variant="body2">
                                        Status
                                    </Typography>
                                </TableCell>
                                <TableCell component="th" scope="row">
                                    <TextField source="status" />
                                </TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell
                                    component="th"
                                    scope="row"
                                    sx={{ width: 300 }}
                                >
                                    <Typography component="span" variant="body2">
                                        Type
                                    </Typography>
                                </TableCell>
                                <TableCell component="th" scope="row">
                                    <TextField source="type" />
                                </TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell
                                    component="th"
                                    scope="row"
                                    sx={{ width: 300 }}
                                >
                                    <Typography component="span" variant="body2">
                                        Coin Address
                                    </Typography>
                                </TableCell>
                                <TableCell component="th" scope="row">
                                    <div className="data-cell__copy-to-clipboard">
                                        <TextField source="coinAddress" />{" "}
                                        <CopyToClipboardButton source="coinAddress" />
                                    </div>
                                </TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell
                                    component="th"
                                    scope="row"
                                    sx={{ width: 300 }}
                                >
                                    <Typography component="span" variant="body2">
                                        Owner Address
                                    </Typography>
                                </TableCell>
                                <TableCell component="th" scope="row">
                                    <div className="data-cell__copy-to-clipboard">
                                        <TextField source="ownerAddress" />{" "}
                                        <CopyToClipboardButton source="ownerAddress" />
                                    </div>
                                </TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell
                                    component="th"
                                    scope="row"
                                    sx={{ width: 300 }}
                                >
                                    <Typography component="span" variant="body2">
                                        Host Address
                                    </Typography>
                                </TableCell>
                                <TableCell component="th" scope="row">
                                    <div className="data-cell__copy-to-clipboard">
                                        <TextField source="hostAddress" />{" "}
                                        <CopyToClipboardButton source="hostAddress" />
                                    </div>
                                </TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell
                                    component="th"
                                    scope="row"
                                    sx={{ width: 300 }}
                                >
                                    <Typography component="span" variant="body2">
                                        Author
                                    </Typography>
                                </TableCell>
                                <TableCell component="th" scope="row">
                                    <AuthorField source="authorId" />
                                </TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell
                                    component="th"
                                    scope="row"
                                    sx={{ width: 300 }}
                                >
                                    <Typography component="span" variant="body2">
                                        Author email
                                    </Typography>
                                </TableCell>
                                <TableCell component="th" scope="row">
                                    <EmailField source="authorEmail" />
                                </TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell
                                    component="th"
                                    scope="row"
                                    sx={{ width: 300 }}
                                >
                                    <Typography component="span" variant="body2">
                                        AuthorId
                                    </Typography>
                                </TableCell>
                                <TableCell component="th" scope="row">
                                    <div className="data-cell__copy-to-clipboard">
                                        <TextField source="authorId" />{" "}
                                        <CopyToClipboardButton source="authorId" />
                                    </div>
                                </TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell
                                    component="th"
                                    scope="row"
                                    sx={{ width: 300 }}
                                >
                                    <Typography component="span" variant="body2">
                                        Tenant
                                    </Typography>
                                </TableCell>
                                <TableCell component="th" scope="row">
                                    <div className="data-cell__copy-to-clipboard">
                                        <TextField source="tenantId" />{" "}
                                        <CopyToClipboardButton source="tenantId" />
                                    </div>
                                </TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell
                                    component="th"
                                    scope="row"
                                    sx={{ width: 300 }}
                                >
                                    <Typography cosmponent="span" variant="body2">
                                        Date
                                    </Typography>
                                </TableCell>
                                <TableCell component="th" scope="row">
                                    <TimestampDateTimeField source="date" />
                                </TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell
                                    component="th"
                                    scope="row"
                                    sx={{ width: 300 }}
                                >
                                    <Typography cosmponent="span" variant="body2">
                                        Start
                                    </Typography>
                                </TableCell>
                                <TableCell component="th" scope="row">
                                    <TimestampDateTimeField source="startDate" />
                                </TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell
                                    component="th"
                                    scope="row"
                                    sx={{ width: 300 }}
                                >
                                    <Typography cosmponent="span" variant="body2">
                                        Expire
                                    </Typography>
                                </TableCell>
                                <TableCell component="th" scope="row">
                                    <TimestampDateTimeField source="expireDate" />
                                </TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell
                                    component="th"
                                    scope="row"
                                    sx={{ width: 300 }}
                                >
                                    <Typography cosmponent="span" variant="body2">
                                        Update
                                    </Typography>
                                </TableCell>
                                <TableCell component="th" scope="row">
                                    <TimestampDateTimeField source="updatedAt" />
                                </TableCell>
                            </TableRow>
                        </Table>
                    </TableContainer>
                </Tab>
            </TabbedShowLayout>
        </>
    </Show>
};